﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getWebContent, getWebContents, saveWebContent } from "@/api/Maintainers/web_contents";

const key = "web_contents";

export function useWebContent(selected) {
	return useQuery([key, selected], () => selected && getWebContent({ selected }));
}

export function useWebContentPaginate(params) {
	return useQuery([key, params], () => getWebContents(params));
}

export function useMutateWebContent(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveWebContent, {
		onSuccess: (response) => {
			const web_contents = _.omit(response, "detail");
			const web_content = _.omit(response, key);

			queryClient.setQueryData([key, String(web_content.detail.id)], web_content);
			queryClient.setQueryData([key, params], web_contents);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/contenidos_web");
		},
	});
}
